import { ReactNode } from "react";

export const ActionsWrapper = ({ children }: { children: ReactNode }) => (
  <div className="flex justify-end mt-4 space-x-4">{children}</div>
);
